<template>
  <el-dialog title="暗链检测" width="600px" :visible.sync="darkLinkShow" :before-close="close">
    <div class="type">
      <div class="log-box">
        <div
            @click="changeType(1)"
            :style="{
            color: type == 1 ? '#1890FF' : '',
            borderBottom: type == 1 ? 'solid 1px #dcdfe6' : '',
          }"
            class="log"
        >
          疑似暗链
        </div>
        <div
            @click="changeType(2)"
            :style="{
            color: type == 2 ? '#1890FF' : '',
            borderBottom: type == 2 ? 'solid 1px #dcdfe6' : '',
          }"
            class="log"
        >
          白名单链接
        </div>
      </div>
      <div class="dir"></div>
      <div class="option" v-if="type ==1">
        <div class="opt-text">共 <span>{{ linksData.darkUrlList?.length }}</span> 条疑似暗链</div>
        <div class="opt">
          <span @click="openChooseColumn()">重新检测</span>
          <span @click="alldeChain()">全部去链</span>
        </div>
      </div>
      <div v-if="type ==1" class="box">
        <div v-for="(item,index) in linksData.darkUrlList" class="an-lian-box">
          <div><a>{{ item }}</a></div>
          <div style="width:100px;text-align: center"><a @click="deleteLink(index,item)">去链</a></div>
        </div>
      </div>
      <div v-if="type ==2" class="box">
        <div v-for="(item,index) in linksData.whiteUrlList" class="an-lian-box">
          <div><a>{{ item }}</a></div>
          <div style="width:100px;text-align: center"><a @click="deleteWhiteLink(index,item)">去链</a></div>
        </div>
      </div>
    </div>
    <div style="margin-top: 30px;text-align: right;">
      <el-button style="padding:10px 24px" size="small" @click="close">取消</el-button>
      <el-button @click="submitFn" style="padding:10px 24px" size="small" type="primary">保存</el-button>
    </div>
    <div id="qu-lian" v-show="false" v-html="editorHtml"></div>
  </el-dialog>
</template>
<script>
import {darkChainDetection} from './manuscripts'
import {Loading} from "element-ui";

export default {
  props: {
    darkLinkShow: {
      type: Boolean,
      default: false,
    },
    editorHtml: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      editorContent:"",
      title: '',
      abstractText: '',
      content: '',
      type: 1,
      linksData: [],
      deleteLinkData: [],
    }
  },
  mounted() {
    this.editorContent=this.editorHtml;
    this.openChooseColumn();
  },
  methods: {
    openChooseColumn() {
      let loadingInstance = Loading.service({fullscreen:true});
      darkChainDetection({
        html: this.editorContent,
        siteId: sessionStorage.getItem('siteId')
      }).then((res) => {
        if (res.code == 0) {
          this.linksData = res.data;
        }
        loadingInstance.close();
      }).catch(()=>{
        loadingInstance.close();
      })
    },
    deleteLink(index, item) {
      this.linksData.darkUrlList.splice(index, 1);
      this.deChain(item);
    },
    deleteWhiteLink(index, item) {
      this.linksData.whiteUrlList.splice(index, 1)
      this.deleteLinkData.push(item)
    },
    close() {
      this.$emit('closeMisse')
    },
    changeType(type) {
      this.type = type;
    },
    alldeChain(){
      if(this.linksData.darkUrlList.length>0){
        this.deleteLink(0,this.linksData.darkUrlList[0]);
        setTimeout(()=>{
          this.alldeChain();
        },50)
      }
    },
    deChain(url){
      let domObj = new DOMParser().parseFromString(this.editorContent, "text/html").body;
      const a=domObj.getElementsByTagName("a");
      for(let i=0;i<a.length;i++){
        if(url===a[i].getAttribute("href")){
          a[i].removeAttribute("href")
        }
      }
      this.editorContent=domObj.innerHTML;
    },
    submitFn(){
      this.$emit('removeLink', this.editorContent);
    }
  }

}
</script>
<style lang="less" scoped>
.content {
  display: flex;

  .left {
    width: 688px;

    .title {
      /deep/ .el-input {
        border-bottom: 1px solid #eeebeb;
        padding: 10px 0;
      }

      /deep/ .el-input__inner {
        border: none;
        color: #303133;
        font-size: 21px;
        font-weight: bold;

      }

      /deep/ input::-webkit-input-placeholder {
        color: #303133;
        font-size: 21px;
        font-weight: bold;
      }
    }

    .abstract {
      padding: 10px 0;
      border-bottom: 1px solid #eeebeb;

      /deep/ input::-webkit-input-placeholder {
        color: #415058;
        font-size: 14px;
      }

      /deep/ .el-input__inner {
        border: none;
      }
    }

    .article {
      margin-top: 30px;

      /deep/ .el-textarea__inner {
        border: none;
      }
    }
  }

  .rgith {
    width: 462px;
    margin-left: 30px;
    // border: 1px solid #d9d9d9;
    /deep/ .el-button {
      border: none;
      padding: 10px 0;
      color: #1890ff;
    }

    .tips {
      color: #101010;
      height: 56px;
      line-height: 56px;
      border-radius: 6px 6px 0px 0px;
      background-color: #f7f7f7;
      border: 1px solid #d9d9d9;
      padding: 0 10px;
    }

    .info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      flex-wrap: nowrap;
      border-bottom: 1px solid #d9d9d9;

      .count {
        color: red;
      }
    }

    .item {
      display: flex;
      justify-content: space-between;
    }
  }

}

.log-box {
  //border-bottom: solid 1px #dcdfe6;
  display: flex;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;

  .log {
    padding: 10px 20px;
    border-top: solid 2px #dcdfe6;
    border-left: solid 2px #dcdfe6;
    cursor: pointer;
    border-bottom: solid 2px #dcdfe6;
  }

  .log:last-child {
    border-right: solid 2px #dcdfe6;
    border-top-right-radius: 10px;
  }

  .log:first-child {
    border-top-left-radius: 10px;
  }
}

.dir {
  height: 2px;
  background: #dcdfe6;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: -2px;
}

.option {
  width: 512px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  margin: 0 auto;
  border-bottom: solid 2px #dcdfe6;
  color: #000;
  font-size: 16px;

  > .opt-text {
    padding-left: 20px;

    > span {
      color: red
    }
  }

  > .opt {
    display: flex;
    align-items: center;
    width: 170px;
    justify-content: space-between;
    color: #1990ff;
    padding-right: 10px;

    > span {
      cursor: pointer;

      &:hover {
        color: rgba(25, 144, 255, .7)
      }
    }
  }
}

.an-lian-box {
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
}

.box {
  padding: 24px;
  max-height: 50vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b2b2b2;
    border-radius: 32px;
    transition: all .2s;

    &:hover {
      background: rgba(178, 178, 178, 0.8);
    }
  }

  &::-webkit-scrollbar-track {
    background: #e1e1e1;
    border-radius: 32px;
  }
}
</style>